"use client";

import { useState, useCallback } from "react";
import Link from "next/link";
import { RotateCcw } from "lucide-react";
import Logo from "~/components/logo";
import { Button } from "~/components/ui/button";
import { ChatArea } from "./chat-area";

export function PublicAsistentPage() {
  const [chatKey, setChatKey] = useState(0);

  const handleNewConversation = useCallback(() => {
    setChatKey((k) => k + 1);
  }, []);

  return (
    <div className="flex h-dvh">
      <div className="flex min-w-0 flex-1 flex-col">
        <ChatArea
          key={chatKey}
          onNewConversation={handleNewConversation}
          initialConversationId={null}
          viewer={null}
          headerLeft={
            <Link href="/" aria-label="Početna">
              <Logo surface="light" />
            </Link>
          }
          headerRight={
            <Button
              variant="ghost"
              size="sm"
              className="text-muted-foreground"
              onClick={handleNewConversation}
            >
              <RotateCcw className="mr-1.5 h-3.5 w-3.5" />
              Novi razgovor
            </Button>
          }
        />
      </div>
    </div>
  );
}
